import { type SwanFormStorageShape } from "../types";
import PersistedStorage from "./PersistedStorage";

class FormsStorage extends PersistedStorage<SwanFormStorageShape> {
  STORAGE_KEY = "swanForms";
}

export default FormsStorage;
